import React from 'react'
import { Row, Col, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
function PositionTableWC() {
    const positions = useSelector((state) => state.positions) || [];
    const netQty = useSelector((state) => state.netQty) || 0;
    const mtm = useSelector((state) => state.mtm) || 0.00;  
  return (
    <div>
         {/* Positions Table */}
         <Row>
        <Col>
          <div className="d-flex justify-content-between mb-2">
            <div>Net Qty: {netQty}</div>
            <div>MTM: {mtm.toFixed(2)}</div>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Symbol Name</th>
                <th>Net Qty</th>
                <th>Avg Price</th>
                <th>LTP</th>
                <th>P&L</th>
              </tr>
            </thead>
            <tbody>
              {positions.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">No Rows To Show</td>
                </tr>
              ) : (
                positions.map((position, index) => (
                  <tr key={index}>
                    <td>{position.symbolName}</td>
                    <td>{position.netQty}</td>
                    <td>{position.avgPrice}</td>
                    <td>{position.ltp}</td>
                    <td>{position.pnl}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  )
}

export default PositionTableWC
